import React, { useState } from 'react';
import { string, arrayOf, shape, func } from 'prop-types';
import {
  DropDown, DropDownItem, DropDownSearch
} from '@thd-olt-component-react/core-ui';
import { I_DONT_KNOW } from '../../../constants';
import styles from './car-picker-dropdown-with-search.module.scss';

export const CarPickerDropDownWithSearch = ({
  header, selectOption, options, onSelect
}) => {
  const [searchField, setSearchField] = useState('');
  return (
    <DropDown
      header={header}
      className={styles['car-picker-dropdown__items']}
    >
      {/* core-ui component does not support removing border or removing autocomplete,
      but the DropDown core-ui component only supports the core-ui DropDownSearch */}
      <DropDownSearch onChange={(searchEvent) => setSearchField(searchEvent)} />
      { selectOption && (
        <DropDownItem>
          {selectOption}
        </DropDownItem>
      )}
      {options?.filter(({ value }) => (
        value?.toLowerCase().includes(searchField.toLowerCase()) || value === I_DONT_KNOW
      )).map(({ id, value, option }, index) => (
        <DropDownItem onClick={() => onSelect({ id, value, option, index })} key={value}>
          {value}
        </DropDownItem>
      )
      )}
    </DropDown>
  );
};

CarPickerDropDownWithSearch.propTypes = {
  header: string,
  selectOption: string,
  options: arrayOf(shape({
    id: string,
    value: string,
    option: string
  })),
  onSelect: func
};

CarPickerDropDownWithSearch.defaultProps = {
  header: null,
  options: [],
  onSelect: () => {},
  selectOption: null
};